module.exports = __webpack_public_path__ + "static/media/hero-retail.e7e30c2c.jpg";